import React, { useContext, useRef } from "react";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { CSSTransition } from "react-transition-group";
import { RTLContext } from "./AccountHome";
import { useAppContext } from "../../context/appContext";
import { Avatar } from "primereact/avatar";
import TokenService from "../../utils/TokenService";

const AppTopbar = (props) => {
    const isRTL = useContext(RTLContext);
    const { userName } = useAppContext();
    const navigate = useNavigate();
    const topbarRef4 = useRef(null);

    const logoutClicked = (e) => {
        navigate("/logout");
    };

    const selectProviderClicked = (e) => {
        navigate("/account/select-provider");
    };

    const myAccountClicked = (e) => {
        navigate("/account/profile");
    };

    const myReviewsClicked = (e) => {
        navigate("/account/my-reviews");
    };

    const myFriendsClicked = (e) => {
        navigate("/account/my-friends");
    };

    const homeClicked = (e) => {
        window.location.href = process.env.REACT_APP_PUBLIC_SITE + "/";
    };

    return (
        <div className={classNames("layout-topbar layout-topbar-fixed shadow-4", { 'bg-blue-100': TokenService.isImpersonating() })}>
            <div className={classNames("layout-topbar-left ", { 'bg-blue-100': TokenService.isImpersonating() })}>
                <a href={process.env.REACT_APP_PUBLIC_SITE} className="p-2 pl-5">
                    <img
                        id="app-logo"
                        src="/assets/layout/images/WallistLogo_Black.png"
                        alt="Wallist Logo"
                        height={48}
                        width={185}
                    />
                </a>
                {TokenService.isImpersonating() && (
                    <div className="hidden sm:flex text-800 mr-3 font-medium ml-5 text-xl align-items-center">
                        <i className="pi pi-box pr-2" style={{ fontSize: '1.2rem' }}></i>{TokenService.getProviderName()}
                    </div>
                )}
                <button type="button" className="layout-topbar-mobile-button p-link" onClick={props.onMenuButtonClick}>
                    <i className="pi pi-bars fs-large"></i>
                </button>
            </div>

            <div
                className={classNames("layout-topbar-right", {
                    "layout-topbar-mobile-active": props.mobileTopbarActive,
                })}
            >
                <div className="layout-topbar-actions-left fs-large"></div>
                <div className="layout-topbar-actions-right">
                    <ul className="layout-topbar-items">
                        <li className="layout-topbar-item">
                            {TokenService.getProviderSubdomain() && (
                                <a href="#" onClick={() => window.location.href = TokenService.getProviderUrl()} className="cursor-pointer mainMenuLink">
                                    <i className="pi pi-home pr-2"></i>Service Manager
                                </a>
                            )}
                            <Avatar
                                className="mr-3"
                                label={userName.substring(0, 1).toUpperCase()}
                                size="large"
                                style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
                                shape="circle"
                                onClick={(event) => props.onTopbarItemClick({ originalEvent: event, item: "profile" })}
                            />

                            <CSSTransition
                                nodeRef={topbarRef4}
                                classNames="p-toggleable"
                                timeout={{ enter: 1000, exit: 450 }}
                                in={props.activeTopbarItem === "profile"}
                                unmountOnExit
                            >
                                <ul ref={topbarRef4} className="layout-topbar-action-panel shadow-6">
                                    <li className="layout-topbar-action-item p-0">
                                        <Button type="link" onClick={selectProviderClicked} className="p-button-text w-full">
                                            <i
                                                className={classNames("pi pi-briefcase", {
                                                    "mr-2": !isRTL,
                                                    "ml-2": isRTL,
                                                })}
                                            ></i>
                                            <span>My Companies</span>
                                        </Button>
                                    </li>
                                    <li className="layout-topbar-action-item p-0">
                                        <Button type="link" onClick={myAccountClicked} className="p-button-text w-full">
                                            <i
                                                className={classNames("pi pi-user", {
                                                    "mr-2": !isRTL,
                                                    "ml-2": isRTL,
                                                })}
                                            ></i>
                                            <span>My Account</span>
                                        </Button>
                                    </li>
                                    <li className="layout-topbar-action-item p-0">
                                        <Button type="link" onClick={myReviewsClicked} className="p-button-text w-full">
                                            <i
                                                className={classNames("pi pi-star", {
                                                    "mr-2": !isRTL,
                                                    "ml-2": isRTL,
                                                })}
                                            ></i>
                                            <span>My Reviews</span>
                                        </Button>
                                    </li>
                                    <li className="layout-topbar-action-item p-0">
                                        <Button type="link" onClick={myFriendsClicked} className="p-button-text w-full">
                                            <i
                                                className={classNames("pi pi-users", {
                                                    "mr-2": !isRTL,
                                                    "ml-2": isRTL,
                                                })}
                                            ></i>
                                            <span>My Friends</span>
                                        </Button>
                                    </li>
                                    <li className="layout-topbar-action-item p-0">
                                        <Button type="link" onClick={logoutClicked} className="p-button-text w-full">
                                            <i
                                                className={classNames("pi pi-power-off", {
                                                    "mr-2": !isRTL,
                                                    "ml-2": isRTL,
                                                })}
                                            ></i>
                                            <span>Logout</span>
                                        </Button>
                                    </li>
                                    <li className="p-0">
                                        <hr />
                                    </li>
                                    <li className="p-0">
                                        <div className="pt-1 ml-5 p-1">Logged in as:<br />{TokenService.getUserName()}</div>
                                    </li>
                                </ul>
                            </CSSTransition>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AppTopbar;
